import React from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";

export default function ComingSoon({}) {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				flexGrow: 1,
				display: "flex",
				flexDirection: "column",
				gap: 1,
				alignItems: "center",
			}}
		>
			<Typography variant="h6">{t("comingSoon.title")}</Typography>
			<Typography variant="body1">
				{t("comingSoon.body")}{" "}
				<a id="mail-link" href="mailto:info@applaby.com">
					info@applaby.com
				</a>
			</Typography>
			<Box sx={{ display: "flex", mt: 2 }}>
				<Button
					sx={{
						width: 150,
						color: "white",
						boxShadow: "none",
						fontSize: "12px",
						borderRadius: "80px",
						height: 33,
						padding: "6px 16px",
						"&:hover": {
							width: 150,
							color: "white",
							boxShadow: "none",
							fontSize: "12px",
							borderRadius: "80px",
							height: 33,
							padding: "6px 16px",
						},
					}}
					variant="contained"
					onClick={() => {
						const mailLink = document.querySelector("#mail-link");
						if (mailLink) {
							mailLink.click();
						}
					}}
				>
					{t("comingSoon.contact")}
				</Button>
			</Box>
		</Box>
	);
}
